/** Путь для основного бизнес API (клиентские запросы) */
export const API_BUSINESS_REQUEST_BASE_PATH = '/api/business/v1';

/** Путь для MyStore API (клиентские запросы) */
export const API_MYSTORE_REQUEST_BASE_PATH = '/api/mystore/v1';
